import RemoveIcon from "@mui/icons-material/Remove";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { GridRenderCellParams, GridRowsProp } from "@mui/x-data-grid";
import { IconCircuitGround } from "@tabler/icons-react";
import * as React from "react";
import { useParams } from "react-router-dom";
import theme from "../../../../assets/theme";
import i18nStore from "../../../../i18n/store";
import { GroundingEnum } from "../../schemas/branches";


interface GroundingFieldProps extends GridRenderCellParams {
    updateApiFunc: (projectId: string | number, node: any) => Promise<any>;
    rows: GridRowsProp;
    setRows: (rows: GridRowsProp) => void;
}
const GroundingField = (props: GroundingFieldProps) => {
    const translations = i18nStore.getTranslations;
    const params = useParams();
    const projectId: number = +(params.projectId || 0);

    let color = "red";
    if (props.value === GroundingEnum.GROUNDED) color = "green";

    const toggleGroundingValue = () => {
        if (props.updateApiFunc) {
            const newGrounding = props.value === GroundingEnum.GROUNDED ? GroundingEnum.NOT_GROUNDED : GroundingEnum.GROUNDED;
            props.updateApiFunc(projectId, {...props.row, [props.field]: newGrounding})
                .then(() => {
                    for (let i = 0; i < props.rows.length; i++) {
                        if (props.rows[i].id === props.row.id) {
                            props.setRows([
                                ...props.rows.slice(0, i),
                                {...props.rows[i], [props.field]: newGrounding},
                                ...props.rows.slice(i+1, props.rows.length),
                            ]);
                            break;
                        }
                    }
                });
        }
    };
    if (props.value === GroundingEnum.GROUNDED) {
        return (
            <Tooltip title={translations[props.value.toString().toLowerCase()]} placement="top">
                <Box sx={{ display: "flex", justifyContent: "center", alignItems: "flex-start", position:"relative", top: "-6px" }}>
                    <IconButton onClick={toggleGroundingValue} sx={{color: "green", margin: "auto" }}>
                        <IconCircuitGround />
                    </IconButton>

                </Box>
            </Tooltip>
        );
    }
    return (
        <Tooltip title={translations[props.value.toString().toLowerCase()]} placement="top">
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "flex-start", position:"relative", top: "-6px" }}>
                <IconButton onClick={toggleGroundingValue} sx={{ color: theme.palette.grey.A700 }}>
                    <RemoveIcon color="inherit" />
                </IconButton>
            </Box>
        </Tooltip>
    );
};


export default GroundingField;
